import * as React from "react";
import { Layout, Box, Text, Flex } from "@draftkings/arena-web";
export const GuaranteedPayout = React.memo(function GuaranteedPayout(props) {
    const { label, status, messages, purchaseId, testId } = props;
    return React.createElement(Layout, { variant: "bonus" },
        React.createElement(Flex, { gap: "8px", alignItems: "center", marginRight: "auto" },
            React.createElement(Box, { testId: testId, variant: `button.ghostLeg:${status}` }, label)),
        messages.map((message, index) => React.createElement(Text, { key: `${purchaseId}-${index}`, testId: `message-${purchaseId}-${index}`, variant: `boostMessage${message.type}` }, message.text)));
});
//# sourceMappingURL=GuaranteedPayout.js.map